import * as Sentry from "@sentry/angular";

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, EnvironmentProviders, ErrorHandler, Provider } from '@angular/core';
import { Router, RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';
import { CookieService } from 'ngx-cookie-service';
import { AppInit, initializeApp } from './app.init';
import { ErrorInterceptor } from './framework/error-interceptor';
import { TokenAuthInterceptor } from './framework/token-auth-interceptor';
import { LoadingService } from './services/loading.service';

export const providers: (Provider | EnvironmentProviders)[] = [
  // ...
  {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler(),
  },
  {
    provide: Sentry.TraceService,
    deps: [Router],
  },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => { },
    deps: [Sentry.TraceService],
    multi: true,
  },
  provideHttpClient(withInterceptorsFromDi()),

  { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  { provide: APP_INITIALIZER, useFactory: initializeApp, multi: true, deps: [AppInit] },

  { provide: HTTP_INTERCEPTORS, useClass: TokenAuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

  { provide: LocationStrategy, useClass: HashLocationStrategy },

  AppInit,

  CookieService,
  LoadingService
];
